var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPersonData = function SvgPersonData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19 4h-4.2a2.96 2.96 0 0 0-5.6 0H5a2.006 2.006 0 0 0-2 2v14a2.006 2.006 0 0 0 2 2h14a2.006 2.006 0 0 0 2-2V6a2.006 2.006 0 0 0-2-2Zm-7 0a1 1 0 0 1 0 2 .945.945 0 0 1-1-1 .945.945 0 0 1 1-1Zm0 4a2.946 2.946 0 0 1 3 3 2.946 2.946 0 0 1-3 3 2.946 2.946 0 0 1-3-3 2.946 2.946 0 0 1 3-3Zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1Z"
  })));
};
export default SvgPersonData;